import { useState, useEffect } from 'react'

/**
 * Custom hook for syncing component state with store
 * @param {Object} store - The store instance
 * @param {string} propertyName - Name of the property in store
 * @param {*} initialValue - Initial value if store property is undefined
 * @returns {[*, Function]} - Tuple of [state, setState]
 */
export function useTableState(store, propertyName, initialValue) {
  const [state, setState] = useState(store[propertyName] !== undefined ? store[propertyName] : initialValue)
  
  useEffect(() => {
    store[propertyName] = state
  }, [state, store, propertyName])
  
  return [state, setState]
}

